var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 17.0394L10.5033 4.66604C10.3327 4.56182 10.1375 4.50492 9.93769 4.50117C9.73786 4.49743 9.54065 4.54699 9.36633 4.64475C9.19201 4.74251 9.04689 4.88495 8.94588 5.05741C8.84487 5.22986 8.79163 5.42612 8.79163 5.62598V30.3728C8.79163 30.5727 8.84487 30.7689 8.94588 30.9414C9.04689 31.1138 9.19201 31.2563 9.36633 31.354C9.54065 31.4518 9.73786 31.5013 9.93769 31.4976C10.1375 31.4938 10.3327 31.4369 10.5033 31.3327L30.75 18.9593C30.9144 18.8588 31.0503 18.7178 31.1446 18.5497C31.2388 18.3816 31.2883 18.1921 31.2883 17.9994C31.2883 17.8067 31.2388 17.6172 31.1446 17.4491C31.0503 17.281 30.9144 17.1399 30.75 17.0394Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/videoPlay.4e1e4dabe27fd64d0668b68c4f778480.svg";
export { ForwardRef as ReactComponent };